/** Chart series colors — patient flow performance chart / legend. */

import { StatusTypes } from '@components/common/StatusBadge/StatusBadge.component'

/** Patient flow statuses — aligned with appointment status labels. */
export const PATIENT_FLOW_STATUS = {
  CONFIRMED: StatusTypes.Confirmed,
  CHECK_IN: StatusTypes.CheckIn,
  CHECK_OUT: StatusTypes.CheckOut,
  IN_TREATMENT: 'In-treatment',
  NO_SHOW: 'No-show',
} as const

export type PatientFlowStatus =
  (typeof PATIENT_FLOW_STATUS)[keyof typeof PATIENT_FLOW_STATUS]

export const PATIENT_FLOW_CHART_SERIES = [
  {
    dataKey: 'scheduled',
    name: PATIENT_FLOW_STATUS.CONFIRMED,
    color: 'var(--blue-400)',
  },
  {
    dataKey: 'checkedIn',
    name: PATIENT_FLOW_STATUS.CHECK_IN,
    color: 'var(--blue-600)',
  },
  {
    dataKey: 'discharged',
    name: PATIENT_FLOW_STATUS.CHECK_OUT,
    color: 'var(--orange-300)',
  },
] as const
